<template>
  <div
    class="widget__wrapper"
    :class="textAlign === 'right' ? 'right-aligned' : ''"
  >
    <h1>
      {{ title }}
    </h1>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetWrapper',
  props: {
    title: String,
    textAlign: {
      type: String,
      default: 'left'
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'Plugins/style/breakpoints';

.widget__wrapper {
  color: white;
  box-sizing: border-box;
  font-size: 0.8em;
  flex: 1;

  &.right-aligned {
    padding: 0 2em 0 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    h1 {
      text-align: right;
    }
  }

  h1 {
    font-size: 0.8em;
    font-weight: 500;
    text-align: left;
    border-bottom: 2px dotted white;
    width: 75%;
  }
  @media (min-width: $phone) and (max-width: $tablet) {
    h1 {
      font-size: 1em;
    }
  }

  @media (min-width: $tablet) and (max-width: $desktop) {
    padding-left: 2em;
    h1 {
      width: 80%;
      font-size: 1.5em;
    }
    &.right-aligned {
      padding: 0 4em 0 0;
    }
  }

  @media (min-width: $desktop) {
    h1 {
      width: 100%;
      font-size: 1.5em;
    }
    &.right-aligned {
      padding: 0 4em 0 0;
    }
  }
}
</style>
